import { getAll2FAs } from '@/api/2fa';
import { mapGetters } from 'vuex';

export const twoFAMixin = {
    data() {
        return {
            secrets: [],
        };
    },
    computed: {
        ...mapGetters('account', ['UserID']),
    },
    methods: {
        async getUser2FAQrcode(project_id = '') {
            let result;
            this.secrets = this.$options.secrets;
            result = await getAll2FAs(this.UserID);
            if (project_id) {
                for (let i = 0; i < result.data.length; i++) {
                    if (result.data[i].app_name == project_id) {
                        this.secrets = [result.data[i]];
                        break;
                    }
                }
            } else {
                this.secrets = result.data;
            }
        },
    },
};
